import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const CreatedByIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 4.5C6.78906 4.5 5 6.28906 5 8.5C5 10.7109 6.78906 12.5 9 12.5C11.2109 12.5 13 10.7109 13 8.5C13 6.28906 11.2109 4.5 9 4.5ZM9 6.5C10.1055 6.5 11 7.39453 11 8.5C11 9.60547 10.1055 10.5 9 10.5C7.89453 10.5 7 9.60547 7 8.5C7 7.39453 7.89453 6.5 9 6.5ZM16.5 6.5C15.1211 6.5 14 7.62109 14 9C14 10.3789 15.1211 11.5 16.5 11.5C17.8789 11.5 19 10.3789 19 9C19 7.62109 17.8789 6.5 16.5 6.5ZM17 12.5C15.5039 12.5 14.4023 13.0273 13.625 13.6563C15.9687 14.9805 16.8828 17 16.9375 17.125L17 17.3125V17.5H22V15.8438C22 15.8438 20.7969 12.5 17 12.5ZM9 13.5C3.68359 13.5 2 17.5 2 17.5V19.5H16V17.5C16 17.5 14.3164 13.5 9 13.5ZM9 15.5C12.4336 15.5 13.5312 17.5 13.5312 17.5H4.46875C4.46875 17.5 5.60937 15.5 9 15.5Z",
      fill: "currentColor"
    }
  ) }),
  "CreatedBy"
);
export {
  CreatedByIcon
};
